import { ForeignCurrencyCostRateCalculationType } from 'further-types/lp/vehicle';

export const ForeignCurrencyCostRateCalculationLabels = {
  [ForeignCurrencyCostRateCalculationType.Average]: 'Average cost',
};
